export default __webpack_public_path__ + "static/media/Frostmaw Vambraces.8a13653d.jpg";